import { CropAid } from 'src/app/crop-aid/crop-aid.model';
import { TreatmentType } from 'src/app/sales-order-period/models/sales-order-period.models';
import {
  TreatmentWithNitrogenEffectivity,
  AidAdviceWithNitrogenEffectivity,
} from 'src/app/shared/models';

export interface RecommendedNutrientQuantityData {
  n?: number;
  p2O5?: number;
  k2O?: number;
  na2O?: number;
  mgO?: number;
  caO?: number;
  sO3?: number;
  b?: number;
  mn?: number;
  fe?: number;
}

export interface RecommendedNutrientQuantityDataWithIds extends RecommendedNutrientQuantityData {
  cropFieldId: number;
}

export const fertilizerElements: (keyof FertilizerData)[] = [
  'n',
  'p2O5',
  'k2O',
  'na2O',
  'mgO',
  'caO',
  'sO3',
  'b',
  'mn',
  'fe',
];

export type FertilizerData = RecommendedNutrientQuantityData;

export interface EditingTreatmentApi {
  periodId: number;
  isAnExecutedTreatment: boolean;
  frequency: number;
  isPrimary: boolean;
  treatmentType: TreatmentType;
  aidAdvices: AidAdviceWithNitrogenEffectivity[];
}

export interface FertilizerReportItemApi {
  name: string;
  cropName: string;
  cropVariety?: string;
  area: number;
  fertilizationItems: FertilizerItemApi[];
}

export interface FertilizerItemApi {
  source: string;
  fertilizerData: FertilizerData;
  primary: boolean;
  displayDosage?: string;
  isExecuted?: boolean;
  note?: string;
}

export interface FertilizerTable {
  metaData: { name: string; cropName: string; cropVariety?: string; area: number };
  fertilizationItems: FertilizerItem[];
}

export interface FertilizerItem {
  source: string;
  data: FertilizerData;
  primary: boolean;
  isExecuted?: boolean;
  note?: string;
}

export interface AdvicedFertilizers extends FertilizerItem {
  displayDosage: string;
  adviceId?: number;
}

export interface FertilizerAidAdvice extends AidAdviceWithNitrogenEffectivity {
  primary: boolean;
  isAnExecutedTreatment: boolean;
  cropAid: CropAid;
  periodId: number;
  frequency: number;
}

export interface FertilizerAidAdviceWithNitrogenEffectivity
  extends AidAdviceWithNitrogenEffectivity {
  primary: boolean;
  isAnExecutedTreatment: boolean;
  cropAid: CropAid;
}

export interface FertilizerProps {
  elements: (keyof FertilizerData)[];
  treatments?: TreatmentWithNitrogenEffectivity[];
  areExecutedTreatments: boolean;
}
